/* istanbul ignore file */

import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { hideScrollbar, mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

export const mobileEdgeToEdge = css`
  margin: 0 calc(-1 * var(${spacing.md}));

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0;
    `,
  )}
`;

export const mainMediaWrapperWithThumbnails = css`
  position: relative;
  display: flex;
  overflow-x: auto;
  scroll-behavior: auto;
  scroll-snap-type: x mandatory;

  ${hideScrollbar}

  &[data-media-focus='true'] {
    box-shadow: 0 0 0 3px var(--neutral-white-base), 0 0 0 5px var(--brand-purple-base);
  }
`;

export const carouselSlide = css`
  scroll-snap-align: center;
  scroll-snap-stop: always;
  min-width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
`;

export const carouselContainer = css`
  position: relative;
`;

export const mainMedia = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const favouriteButton = css`
  position: absolute;
  right: 12px;
  top: 12px;
`;

export const imageNumberLabelContainer = css`
  position: absolute;
  bottom: 12px;
  left: 12px;
`;
